import Base from './Base';

class Partner extends Base {

    constructor () {
        super();
        this.endpoint = 'partner';
    }

    getAll( ) {
        return  fetch(this.getUrlEndpoint("retrieve/"),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    getEntregas( ) {
        return  fetch(this.getUrlEndpoint("retrieve/entregas"),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    updateStatus( id,status ) {
        var data = {
            status
        }
        return  this.requestData(data).then( (sData) => {
            return fetch(this.getUrlEndpoint("updateStatus/"+id),{
                method: 'PATCH',
                headers: this.headers,
                body: sData
            }).then( response => response.json() )
        })
    }

    getContractUrl( id ) {
        return this.baseUrl + this.endpoint + "/download-contract/"+id
    }

    getSolicitudUrl( id ) {
        return this.baseUrl + this.endpoint + "/download-solicitud/"+id
    }

    getEntregaUrl( id ) {
        return this.baseUrl + this.endpoint + "/download-entrega/"+id
    }

    sendCuenta( id ){
        return  fetch(this.getUrlEndpoint("enviar-cuenta/"+id),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }
    

    
    
}

export default Partner;